import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { requestInit } from 'universal-scripts'
import { UserState } from 'src/types/auth'

const initialState: UserState = null

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(_, action: PayloadAction<UserState>) {
      return action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(requestInit, (state, action) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const auth = (action as any).payload?.auth
      return auth || state
    })
  }
})

export const { setUser } = userSlice.actions
export default userSlice.reducer
